const GET_PREVIOUS_ALERTS = "GET_PREVIOUS_ALERTS";
const GET_PREVIOUS_ALERTS_SUCCESS = "GET_PREVIOUS_ALERTS_SUCCESS";
const GET_PREVIOUS_ALERTS_ERROR = "GET_PREVIOUS_ALERTS_ERROR";

export {
  GET_PREVIOUS_ALERTS,
  GET_PREVIOUS_ALERTS_SUCCESS,
  GET_PREVIOUS_ALERTS_ERROR,
};
